import { uniqueId } from 'lodash'
import { FINANCE_SERVER } from '@/constants/domains'
import { AED_ICON, ARTICLE_ICON, DOWNLOAD_ICON } from '@/constants/icons'
import { REMINDER_STATUS } from '@/constants/recurReminders'
import { NOT_PAID } from '@/constants/projectStatuses'
import {SIDE_HOURLY, HOURLY} from '@/constants/projectTypes'
const columns = [
  {
    type: 'menu',
    completeProject: true,
    width: '23px',
    hideCompleted: true,
    showSemiCompleted: false,
    showDeleted: true,
    getValue: (projectType) => projectType.id === SIDE_HOURLY.id,
    isDisabled: 'isProject'
  },
  {
    type: 'index',
    width: '22px'
  },
  {
    title: 'Client',
    display: 'client.nickName',
    prop: 'client',
    route: {
      name: 'ContactCard',
      paramName: 'id',
      paramValue: 'client.id',
      paramName2: 'contactType',
      paramValue2: 'client.contactType',
      newWindow: true
    },
    mark: {
      text: ['DUP', 'KPI', 'KPI'],
      display: ['isDouble', 'invoiceId._id', 'includeOfKpi']
    },
    popup: {
      isShowModalOnKpi: true,
      text: 'projectManager.username',
      prop: 'projectManager.id'
    },
    icon: {
      model: 'rejectedStatus',
      popup: 'rejectedComments'
    },
    width: 'minmax(100px, 1fr)',
    customStyle: {
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      wordBreak: 'break-word',
      '-webkit-box-orient': 'vertical'
    }
  },
  {
    type: 'mark',
    name: 'SUB',
    getValue: (projectType) => projectType.id === SIDE_HOURLY.id,
    getHourProject: (projectType) => projectType.id === HOURLY.id,
    width: '30px'
  },
  {
    title: 'Project name',
    prop: 'name',
    isHashtag: 'tags',
    popup: 'projectDescription',
    route: {
      name: 'ProjectCard',
      paramName: 'projectId',
      paramValue: 'id'
    },
    width: 'minmax(385px, 3fr)',
    notification: true,
    notificationPopup: 'lastStep.comment',
    updateProject: true,
    isDynamic: true,
    customStyle: {
      wordBreak: 'break-all'
    }
  },
  {
    title: '%',
    type: 'percentComplete',
    prop: 'totalPercent',
    defaultValue: 'stepServiceProject',
    items: 'typeServiceProject.stepServiceProject',
    settings: {
      key: '_id',
      value: 'name',
      color: 'color',
      isActive: '_id'
    },
    isNoClick: false,
    width: 'minmax(95px, 95px)'
  },
  {
    title: 'Est. Start Date',
    type: 'dateChoose',
    hideHead: true,
    isCalendarFilter: true,
    prop: 'estStartDate',
    sortBy: 'estStartDate',
    calendarSettings: {
      mode: 'single',
      model: 'estStartDate',
      format: 'DD-MMM'
    },
    calendarFilterSettings: {
      model: 'estStartDate',
      format: 'DD.MM.YY',
      mode: 'range',
      isFull: true
    },
    estStartDate: '',
    activeFilter: false,
    isNoClick: false,
    width: 'minmax(130px, 130px)'
  },
  {
    title: 'Est. Completion',
    type: 'dateChoose',
    isCalendarFilter: true,
    prop: 'estCompletion',
    sortBy: 'estCompletion',
    calendarSettings: {
      mode: 'single',
      model: 'estCompletion',
      format: 'DD-MMM'
    },
    calendarFilterSettings: {
      model: 'estCompletion',
      format: 'DD.MM.YY',
      mode: 'range',
      isFull: true
    },
    estCompletion: '',
    activeFilter: false,
    isNoClick: false,
    width: 'minmax(130px, 130px)'
  },
  {
    title: 'Time',
    type: 'timer',
    prop: 'totalTime',
    status: 'subTimers',
    instanceStatus: REMINDER_STATUS.PROJECT,
    isNoClick: false,
    width: 'minmax(85px, 85px)'
  },
  {
    title: 'Value,',
    iconTitle: AED_ICON,
    iconStyle: {
      margin: '0 0 0 2px'
    },
    type: 'number',
    prop: 'factValue',
    action: 'openInvoice',
    file: {
      from: FINANCE_SERVER,
      prop: 'invoiceId.uploadFile[0]',
      icon: DOWNLOAD_ICON
    },
    icon: {
      type: ARTICLE_ICON,
      className: '__icon-article'
    },
    popupModal: {
      isShowFile: true,
      prop: 'invoiceNumber'
    },
    className: true,
    statusProject: NOT_PAID.id,
    width: 'minmax(125px, 150px)'
  },
  {
    title: 'Deleted on',
    prop: 'lostDate',
    type: 'date',
    showDeletedOn: true
  },
  {
    title: 'Reason',
    prop: 'comments',
    type: 'largeText',
    showDeletedOn: true
  },
  {
    title: 'Completed',
    prop: 'dateEnd',
    type: 'date',
    width: '85px',
    hideProgress: true
  },
  {
    title: 'Contact PM',
    type: 'addUserSelect',
    prop: 'contactPm',
    filterBy: 'contactPm',
    items: [],
    options: [],
    width: 'minmax(84px, 84px)',
    isClosePanel: true,
    isNoClick: false,
    activeFilter: false,
    styleIcon: {
      margin: '0 15px 0 0'
    }
  },
  {
    title: 'Support',
    type: 'addUserSelect',
    prop: 'supportManager',
    filterBy: 'supportManager',
    width: 'minmax(64px, 64px)',
    items: [],
    options: [],
    isClosePanel: true,
    isNoClick: false,
    activeFilter: false,
    styleIcon: {
      margin: '0 17px 0 0'
    }
  },
  {
    title: 'Start date',
    prop: 'commentStartDate',
    sortBy: 'commentStartDate',
    type: 'date',
    showDeleted: true,
    width: '80px'
  },
  {
    title: 'Last update',
    prop: 'dateLastUpdate',
    type: 'date',
    width: '85px',
    sortBy: 'dateLastUpdate',
    hideCompleted: true,
    showSemiCompleted: true
  },
  {
    title: 'Reminders',
    prop: 'reminders',
    type: 'reminder',
    reminderStatus: REMINDER_STATUS.PROJECT,
    isNoClick: false,
    width: '58px'
  }
]

const prefix = 'col_projects_'
const listOfProjectColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export default listOfProjectColumns



// WEBPACK FOOTER //
// ./src/constants/TablesSettings/listOfProjectColumns.js